import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function RightIcon({
  size = "24",
  color = MAIN_THEME.colors.brandWhite,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 9 13"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.79297 7.21484C7.92969 7.10547 8.01172 6.94141 8.01172 6.75C8.01172 6.58594 7.92969 6.42188 7.79297 6.28516L2.48828 0.980469C2.35156 0.871094 2.1875 0.789062 2.02344 0.789062C1.83203 0.789062 1.66797 0.871094 1.55859 0.980469L0.957031 1.58203C0.820312 1.71875 0.738281 1.88281 0.738281 2.04688C0.738281 2.23828 0.792969 2.40234 0.929688 2.51172L5.16797 6.75L0.929688 10.9883C0.792969 11.125 0.738281 11.2891 0.738281 11.4531C0.738281 11.6445 0.820312 11.8086 0.957031 11.918L1.55859 12.5195C1.66797 12.6562 1.83203 12.7109 2.02344 12.7109C2.1875 12.7109 2.35156 12.6562 2.48828 12.5195L7.79297 7.21484Z"
        transform="translate(0 -0.0429688)"
        fill={color}
      />
    </svg>
  );
}
